export default "__VITE_PUBLIC_ASSET__03d8e9ba__"